"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotEmpty = void 0;
const ramda_1 = require("ramda");
exports.isNotEmpty = (0, ramda_1.compose)(ramda_1.not, ramda_1.isEmpty);
